import { cn } from "../lib/utils.js";
import { useFieldContext } from "./field-context.js";
import "./field-affix.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/input-base.tsx
const HIDE_NUMBER_STEPPER = "tw:[appearance:textfield] tw:[&::-webkit-outer-spin-button]:appearance-none tw:[&::-webkit-inner-spin-button]:appearance-none";
const InputBase = ({ className, type, id, disabled, required, ref, prefix, suffix, wrapperClassName, "aria-describedby": ariaDescribedBy, "aria-invalid": ariaInvalid, "aria-required": ariaRequired, ...props }) => {
	const ctx = useFieldContext();
	const hasAffix = prefix != null || suffix != null;
	const input = /* @__PURE__ */ jsx("input", {
		ref,
		type,
		"data-slot": "input",
		id: id ?? ctx?.id,
		"aria-describedby": ariaDescribedBy ?? ctx?.ariaDescribedBy,
		"aria-invalid": ariaInvalid ?? ctx?.invalid,
		"aria-required": ariaRequired ?? ctx?.required,
		disabled: disabled ?? ctx?.disabled,
		required: required ?? ctx?.required,
		className: cn("tw tw:bg-white tw:text-foreground", "tw:flex tw:h-8 tw:min-w-0 tw:px-3 tw:py-1 tw:rounded-xs tw:border", "tw:text-base tw:md:text-sm tw:file:text-sm tw:file:font-medium", "tw:file:text-foreground tw:file:inline-flex tw:file:h-7 tw:file:border-0 tw:file:bg-transparent", "tw:border-input tw:transition-[color] tw:outline-none tw:placeholder:text-midnight/50 tw:selection:bg-primary/10  tw:selection:text-primary-foreground tw:new:selection:text-midnight", "tw:disabled:pointer-events-none tw:disabled:cursor-not-allowed tw:disabled:opacity-50", "tw:focus-visible:border-ring tw:focus-visible:ring-ring/50 tw:focus-visible:ring-[3px] tw:focus:border-primary", "tw:aria-invalid:bg-destructive/5 tw:aria-invalid:selection:bg-destructive/10 tw:aria-invalid:ring-destructive/20 tw:aria-invalid:border-destructive", hasAffix && "tw:w-full", prefix != null && "tw:pl-9", suffix != null && "tw:pr-9", suffix != null && HIDE_NUMBER_STEPPER, className),
		...props
	});
	if (!hasAffix) return input;
	return /* @__PURE__ */ jsxs("div", {
		className: cn("tw:relative tw:flex tw:items-center", wrapperClassName),
		children: [
			prefix != null && /* @__PURE__ */ jsx("span", {
				className: cn("tw:pointer-events-none tw:flex tw:items-center tw:text-base tw:md:text-sm tw:text-midnight/50 tw:[&_svg]:block tw:[&_svg]:size-4", "tw:absolute tw:inset-y-0 tw:left-3"),
				children: prefix
			}),
			input,
			suffix != null && /* @__PURE__ */ jsx("span", {
				className: cn("tw:pointer-events-none tw:flex tw:items-center tw:text-base tw:md:text-sm tw:text-midnight/50 tw:[&_svg]:block tw:[&_svg]:size-4", "tw:absolute tw:inset-y-0 tw:right-3"),
				children: suffix
			})
		]
	});
};
//#endregion
export { InputBase };

//# sourceMappingURL=input-base.js.map